/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { AdcSuppliers } from '../../../../../shared/lists';
import { Component, OnInit } from '@angular/core';
import { RbacService, UtilsService } from '../../../../../../../core/services';
import { SuppliersModel } from '../../../../../shared/models';

@Component({
    selector: 'app-adc-vendor-selection',
    templateUrl: './adc-select-supplier.component.html',
    styleUrls: ['../../../../../../../../assets/shared/scss/page-rows.scss']
})
export class AdcSelectSupplierComponent implements OnInit {
    /**
     * Max limit reached
     */
    public maxLimitReached: boolean = false;

    /**
     * List of suppliers.
     */
    public adcSupplierRows: SuppliersModel[] = [];

    /**
     * Store permissions in lookup table.
     */
    public permissionsLookup: any = {};

    constructor(
        private rbacService: RbacService,
        private utilsService: UtilsService
    ) {
        this.registerButtons();
    }

    ngOnInit(): void {
        this.populateSupplierRows();
    }

    /**
     * Max limit of ADCs reached, disable 'Add' button.
     * @param $event
     */
    public maxLimit($event: any): void {
        this.maxLimitReached = !$event;
    }

    /**
     * Populate supplier rows
     * @private
     */
    private populateSupplierRows(): void {
        const rows: any[] = [];
        for (const supplier of AdcSuppliers) {
            const excludedSuppliers: string[] = ['lbShuttle'];
            if (!excludedSuppliers.includes(supplier.name)) {
                rows.push(supplier);
            }
        }

        this.adcSupplierRows = this.utilsService.sortArrayByProperty(rows, 'active', [true, false]);
    }

    /**
     * Register the page's buttons for RBAC.
     * @private
     */
    private registerButtons(): void {
        const buttonReference: object = {
            'adcs-list-add': [
                { path: '/api/v1/:namespace/adcs/', methods: ['GET', 'POST'] }
            ]
        };

        this.permissionsLookup = this.rbacService.getPermissionsLookup(buttonReference);
    }
}
